// extracted by mini-css-extract-plugin
export default {"pulsatingDotForCopyStyles":"z_cGdJTTH9ntURA7T7OR"};